import * as types from "../actions/invoice.actions";

const INITIAL_STATE = {
  data: {},
  invoices: [],
  invoices_csv: [],
  status: [],
  isSubmitting: false,
  loadingGetInvoices: false
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.GET_INVOICES_START:
      return { ...state, loadingGetInvoices: true };

    case types.GET_INVOICES_SUCCESS:
      return { ...state, invoices: action.data, loadingGetInvoices: false };

    case types.GET_INVOICES_CSV_SUCCESS:
      return {
        ...state,
        invoices_csv: action.data,
        loadingGetInvoices: false
      };

    case types.GET_INVOICES_ERROR:
      return { ...state, loadingGetInvoices: false };

    case types.GET_INVOICE_START:
      return { ...state };

    case types.GET_INVOICE_SUCCESS:
      return { ...state, data: action };

    case types.GET_INVOICE_ERROR:
      return { ...state };

    case types.CREATE_INVOICE_START:
      return { ...state };

    case types.CREATE_INVOICE_SUCCESS:
      return { ...state, data: action.data };

    case types.CREATE_INVOICE_ERROR:
      return { ...state };

    case types.UPDATE_INVOICE_START:
      return { ...state, isSubmitting: true };

    case types.UPDATE_INVOICE_SUCCESS:
      return { ...state, data: action.data, isSubmitting: false };

    case types.UPDATE_INVOICE_ERROR:
      return { ...state, isSubmitting: false };

    case types.UPLOAD_INVOICE_SUCCESS:
      return { ...state };

    case types.GET_INVOICE_STATUS_START:
      return { ...state };

    case types.GET_INVOICE_STATUS_SUCCESS:
      return { ...state, status: action.data };

    case types.GET_INVOICE_STATUS_ERROR:
      return { ...state };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/invoice.reducer.js